import React from 'react';
import './SubscriptionPlans.css';

interface PlanProps {
  selectedPlan: string | null;
  onSelectPlan: (plan: string) => void;
  onContinue: () => void;
  onShowTerms: () => void;
  hasPurchasedPlan?: boolean;
}

const SubscriptionPlans: React.FC<PlanProps> = ({ 
  selectedPlan, 
  onSelectPlan, 
  onContinue,
  onShowTerms,
  hasPurchasedPlan = false
}) => {
  const plans = [
    {
      id: 'weekly',
      title: 'Weekly',
      price: '£3.99/week',
      description: 'Great for regular users'
    },
    {
      id: 'monthly',
      title: 'Monthly',
      price: '£4.99/month',
      description: 'Our most popular plan'
    },
    {
      id: 'yearly',
      title: 'Yearly',
      price: '£49.99/year',
      description: 'Best value for committed foodies'
    }
  ];

  const handlePlanSelect = (plan: string, disabled: boolean) => {
    if (!disabled && !hasPurchasedPlan) {
      onSelectPlan(plan);
    }
  };

  const handleContactSupport = () => {
    const message = `Hi, I have an active subscription and would like to inquire about changing my plan or managing my subscription.`;
    window.open(`https://wa.me/447737024736?text=${encodeURIComponent(message)}`, '_blank');
  };

  if (hasPurchasedPlan) {
    return (
      <section id="subscription-section" className="plans-section">
        <div className="plans-container">
          <div className="active-plan-notice">
            <h3 className="active-plan-title">✅ Subscription Active</h3>
            <p className="active-plan-message">
              You already have an active subscription! You're all set to enjoy all HomeCookt features. 
              If you need to change your plan or have any questions about your subscription, please contact our support team.
            </p>
            <button className="contact-support-button" onClick={handleContactSupport}>
              📞 Contact Support
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="subscription-section" className="plans-section">
      <div className="plans-container">
        <h2 className="plans-heading">Choose Your Subscription Plan</h2>
        <p className="plans-subheading">
          Subscribe to unlock all HomeCookt features and start your culinary journey
        </p>

        <div className="plans-grid">
          {plans.map(plan => (
            <div 
              key={plan.id}
              className={`plan-card ${selectedPlan === plan.id ? 'selected' : ''}`}
              onClick={() => handlePlanSelect(plan.id, false)}
            >
              <h3 className="plan-title">{plan.title}</h3>
              <div className="plan-price">{plan.price}</div>
              <p className="plan-description">{plan.description}</p>
            </div>
          ))}
        </div>

        <p className="benefits-text">
          Subscribing now gives you early access benefits.
          After launch, prices will go up and visibility priority may not be guaranteed.
        </p>

        <button 
          className="continue-button"
          onClick={onContinue}
          disabled={!selectedPlan}
        >
          Continue to Payment
        </button>

        <p className="terms-text">
          By continuing, you agree to our{' '}
          <button onClick={onShowTerms}>Terms & Conditions</button>
        </p>
      </div>
    </section>
  );
};

export default SubscriptionPlans;
